import consumer from "../channels/consumer";

const initDiscussionIndex = () => {
    const container = document.querySelector(".discussions-list");
    if (!container) return;

    const cards = Array.from(container.querySelectorAll(".discussion-card"));
    const discussionIds = cards.map(c => c.dataset.discussionId);

    consumer.subscriptions.create(
        { channel: "DiscussionsChannel", discussion_ids: discussionIds },
        {
            received(data) {
                console.log(data)
                console.log(document.body.dataset.currentUserId)
                if (data.discussion_id && data.last_message) {
                    const card = document.querySelector(`.discussion-card[data-discussion-id="${data.discussion_id}"]`);
                    if (!card) return;

                    const messagePreview = card.querySelector(".discussion-last-message");
                    const timestamp = card.querySelector(".discussion-timestamp");
                    const badge = card.querySelector(".unread-badge");

                    if (messagePreview) messagePreview.textContent = data.last_message;
                    if (timestamp) timestamp.textContent = "à l’instant";

                    const isCurrentUser = Number(data.user_id) === Number(document.body.dataset.currentUserId);
                    console.log(isCurrentUser)
                    console.log(data.unread_count)

                    if (isCurrentUser && data.unread_count > 0) {
                            if (badge) {
                                badge.textContent = data.unread_count;
                            } else {
                                const span = document.createElement("span");
                                span.className = "unread-badge";
                                span.textContent = data.unread_count;
                                card.appendChild(span);
                            }
                    }
                    if (isCurrentUser && data.unread_count === 0) {
                        if (badge) {
                            badge.remove()
                        }
                    }


                    card.dataset.lastMessageTimestamp = new Date(data.last_message_updated_at * 1000).toISOString();
                    const sorted = Array.from(container.children).sort((a, b) => {
                        return new Date(b.dataset.lastMessageTimestamp || 0) - new Date(a.dataset.lastMessageTimestamp || 0);
                    });
                    sorted.forEach(el => container.appendChild(el));

                    card.style.transition = "background-color 0.3s ease";
                    card.style.backgroundColor = "#fff4c4";
                    setTimeout(() => (card.style.backgroundColor = ""), 500);
                }

            }
        }
    );
};

export { initDiscussionIndex };
